


<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h2 class="subtitle-page">Cabecera</h2>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mt-3">
            <form [formGroup]="formCabecera">
                <div class="row">
                    <div class="col-xxl-3 col-md-4 mb-2">
                        <label class="label-form">Tipo Comprobante <i class="fas fa-asterisk text-danger"></i></label>
                        <select class="form-select" (change)="sendCabecera()" formControlName="tipoCfdi">
                            <option value=null>Selecciona una opción</option>
                            @for (item of listTipoComp; track $index) {
                                <option [value]="item.value">{{item.label}}</option>
                            }
                          </select>
                    </div>
                    <div class="col-xxl-3 col-md-4 mb-2">
                        <label class="label-form"> Fecha y hora <i class="fas fa-asterisk text-danger"></i></label>
                        <input class="form-control" formControlName="fecha" step="1" type="datetime-local" (input)="sendCabecera()">
                    </div>
                    <div class="col-xxl-3 col-md-4 mb-2">
                        <label class="label-form"> Condiciones de pago</label>
                        <input class="form-control" formControlName="condicionesDePago" (input)="sendCabecera()">
                    </div>
                    <div class="col-xxl-3 col-md-4 mb-2" *ngIf="!esTraslado(formCabecera.value['tipoCfdi'])">
                        <label class="label-form">Forma de Pago 
                            <i *ngIf="!esTraslado(formCabecera.value['tipoCfdi'])" class="fas fa-asterisk text-danger"></i>
                        </label>
                    
                            <select2 class="custom-select2"  (open)="this.formCabecera.controls['formaPago'].markAsTouched()" (update)="setFormaPago()" [data]="customListCatFormaPago" infiniteScroll formControlName="formaPago"></select2>
                        
                   
                    </div>
                   
                    <div class="col-xxl-3 col-md-4 mb-2" *ngIf="!esTraslado(formCabecera.value['tipoCfdi'])">
                        <label class="label-form">Método de Pago 
                            <i *ngIf="!esTraslado(formCabecera.value['tipoCfdi'])" class="fas fa-asterisk text-danger"></i>
                        </label>
                       
                            <select2 (update)="setMetodoPago()" class="custom-select2" (open)="this.formCabecera.controls['metodoPago'].markAsTouched()" [data]="customListCatMetodoPago" infiniteScroll formControlName="metodoPago"></select2>
                        
   
                    </div>
                
                    <div class="col-xxl-3 col-md-4 mb-2">
                        <label class="label-form">Moneda <i class="fas fa-asterisk text-danger"></i></label>
                        <select2 (update)="sendCabecera()" class="custom-select2" (open)="this.formCabecera.controls['moneda'].markAsTouched()" [data]="customListCatMoneda" infiniteScroll formControlName="moneda"></select2>
                    </div>
                    <div class="col-xxl-3 col-md-4 mb-2">
                        <label class="label-form"> Exportación <i class="fas fa-asterisk text-danger"></i></label>
                        <select class="form-select" (change)="sendCabecera()" formControlName="exportacion">
                            <option value=null>Seleccione una opción</option>
                            @for (item of listExportacion; track $index) {
                                <option [value]="item.value">{{item.label}}</option>
                            }
                          </select>
                    </div>
                    <div class="col-xxl-3 col-md-4 mb-2">
                        <label class="label-form"> Idioma</label>
                        <select class="form-select" (change)="sendCabecera()" formControlName="idioma">
                            <option value=null>Idioma (PDF)</option>
                            @for (item of listIdioma; track $index) {
                                <option [value]="item.value">{{item.label}}</option>
                            }
                          </select>
                    </div>
                    <div class="col-xxl-3 col-md-4 mb-2">
                        <label class="label-form"> Referencia</label>
                        <input class="form-control" formControlName="referencia" (input)="sendCabecera()">
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


